<ng-template vdrDialogTitle>
    <ng-container>{{
        'shopping-list.product-list.assign-customer-to-shopping-list'
            | translate
    }}</ng-container>
</ng-template>

<!-- Split View para exibir a tabela e o painel de detalhes -->
<vdr-split-view>
    <!-- Conteúdo principal à esquerda -->
    <ng-template vdrSplitViewLeft>
        <vdr-data-table-2
            id="partner-list-table"
            class="mt-2"
            [items]="items$ | async"
            [itemsPerPage]="itemsPerPage$ | async"
            [totalItems]="totalItems$ | async"
            [currentPage]="currentPage$ | async"
            (pageChange)="setPageNumber($event)"
            (itemsPerPageChange)="setItemsPerPage($event)"
        >
            <!-- Menu de ações em massa -->
            <vdr-bulk-action-menu
                locationId="partner-list"
                [hostComponent]="this"
                [selectionManager]="selectionManager"
            >
            </vdr-bulk-action-menu>

            <!-- TODO: FIx the search -->
            <!-- <vdr-dt2-search
              [searchTermControl]="searchTermControl"
              [searchTermPlaceholder]="
                  'shopping-list.search-placeholder' | translate
              "
          >
          </vdr-dt2-search> -->

            <!-- Coluna de checkbox de seleção -->
            <vdr-dt2-column id="select">
                <ng-template let-shoppingList="item">
                    <clr-checkbox
                        [clrChecked]="selectionManager.isSelected(shoppingList)"
                        (clrCheckedChange)="toggleSelection(shoppingList)"
                    >
                    </clr-checkbox>
                </ng-template>
            </vdr-dt2-column>

            <vdr-dt2-column [heading]="'ID'" id="id">
                <ng-template let-shoppingList="item">
                    {{ shoppingList.id }}
                </ng-template>
            </vdr-dt2-column>

            <vdr-dt2-column [heading]="'common.image' | translate" id="image">
                <ng-template let-shoppingList="item">
                    <div class="image-placeholder">
                        <img
                            *ngIf="
                                shoppingList.image?.preview as preview;
                                else imagePlaceholder
                            "
                            [src]="preview"
                            alt="{{ shoppingList.name }}"
                            class="partner-image"
                        />
                        <ng-template #imagePlaceholder>
                            <div class="placeholder">
                                <clr-icon shape="image" size="48"></clr-icon>
                            </div>
                        </ng-template>
                    </div>
                </ng-template>
            </vdr-dt2-column>

            <!-- Colunas da Tabela -->
            <vdr-dt2-column
                [heading]="'shopping-list.table-columns.name' | translate"
                id="name"
                [optional]="false"
            >
                <ng-template let-shoppingList="item">
                    <a
                        [routerLink]="[
                            '/extensions/shopping-list/edit',
                            shoppingList.id
                        ]"
                        class="button-ghost"
                    >
                        {{ shoppingList.name }}
                    </a>
                </ng-template>
            </vdr-dt2-column>

            <vdr-dt2-column [heading]="'Token'" id="token">
                <ng-template let-shoppingList="item">
                    {{ shoppingList.token }}
                </ng-template>
            </vdr-dt2-column>
        </vdr-data-table-2>
    </ng-template>
    <!-- Painel direito para exibir os detalhes das Filiais -->
    <ng-template
        vdrSplitViewRight
        [splitViewTitle]="'partners.table-columns.channels' | translate"
    >
        <div>.</div>
    </ng-template>
</vdr-split-view>

<!-- Botões de cancelar/enviar -->
<ng-template vdrDialogButtons>
    <button type="button" class="btn" (click)="cancel()">
        {{ 'common.cancel' | translate }}
    </button>
    <button
        type="submit"
        (click)="assign()"
        [disabled]="selectionManager.selection.length < 1"
        class="btn btn-primary"
    >
        <div *ngIf="selectionManager.selection.length < 1">
            {{ 'shopping-list.product-list.button-assign-empty' | translate }}
        </div>
        <div *ngIf="selectionManager.selection.length == 1">
            {{ 'shopping-list.product-list.button-assign-one' | translate }}
        </div>
        <div *ngIf="selectionManager.selection.length > 1">
            {{
                'shopping-list.product-list.button-assign'
                    | translate
                        : {
                              count: selectionManager.selection.length
                          }
            }}
        </div>
    </button>
</ng-template>
